import React, { useEffect, useState } from "react";
import { Container, Draggable } from "react-smooth-dnd";

import { applyDrag } from "./utils";

const DragHandle = ({ itemsToRender, handleRearrangePriorty }) => {
  const [items, setItems] = useState(itemsToRender);

  useEffect(() => {
    setItems(itemsToRender);
  }, [itemsToRender]);

  const handleDrop = e => {
    const updatedItems = applyDrag(items, e, handleRearrangePriorty);
    setItems(updatedItems);
  };

  return (
    <div>
      <div className="simple-page">
        <Container dragHandleSelector=".column-drag-handle" onDrop={handleDrop}>
          {items.map(item => (
            <Draggable key={item.id}>
              <div style={{ display: "flex" }}>{item.element}</div>
            </Draggable>
          ))}
        </Container>
      </div>
    </div>
  );
};

export default DragHandle;
